import React from 'react';
import { useSignUp } from '@/contexts/signup.context';
import { Input } from '@/components/ui/input';
import { Check } from 'lucide-react';

export const NhssaaView = () => {
	const { parentEmail, setParentEmail } = useSignUp();

	return (
		<div className="flex flex-col w-full text-white pb-6 pt-4 px-4 sm:px-8 md:px-12">
			<div className="flex flex-col gap-[16px] w-full mb-8">
				<div className="bg-[#141821] border border-[#1C2D4A] rounded-[12px] p-[12px] flex items-center gap-[10px] w-full">
					<div className="bg-[#14AE5C] border border-[rgba(20,174,92,0.32)] rounded-full w-[20px] h-[20px] flex items-center justify-center shrink-0">
						<Check className="w-[12px] h-[12px] text-white" strokeWidth={3} />
					</div>
					<p className="text-[14px] leading-normal font-normal">
						We'll email them your username, age, and event information. No photos, contact info, or
						purchases involved.
					</p>
				</div>

				<div className="bg-[#141821] border border-[#1C2D4A] rounded-[12px] p-[12px] flex items-center gap-[10px] w-full">
					<div className="bg-[#14AE5C] border border-[rgba(20,174,92,0.32)] rounded-full w-[20px] h-[20px] flex items-center justify-center shrink-0">
						<Check className="w-[12px] h-[12px] text-white" strokeWidth={3} />
					</div>
					<p className="text-[14px] leading-normal font-normal">
						SportsPredict is free to participate.
					</p>
				</div>
			</div>

			<div className="flex flex-col gap-[12px] w-full">
				<div className="flex items-center justify-between w-full">
					<span className="font-bold text-[14px]">Parent or guardian's email</span>
					<span className="text-[10px] text-[#B5B6BA]">Required</span>
				</div>
				<div className="flex flex-col gap-[12px] w-full">
					<Input
						type="email"
						placeholder="email address"
						className="w-full bg-[#1E2748] border-[#506296] text-white text-[14px] rounded-full h-[44px] px-[16px] focus:outline-none placeholder:text-[#B5B6BA]"
						value={parentEmail}
						onChange={(e) => setParentEmail(e.target.value)}
					/>
					<p className="text-[12px] text-[#B5B6BA] text-center font-medium leading-[14px]">
						This should be your parent or guardian's own email, <br />
						not one you can access.
					</p>
				</div>
			</div>
		</div>
	);
};
